import bugsnag from '@bugsnag/js';

window.Bugsnag = bugsnag(window.bugsnagConfig);
